import { getApi } from 'apis';

const getDashboardSummary = async (params: { payPeriodId: string }) => {
	return await getApi('/dashboard/summary', params);
};

const getDashboardEmployees = async (params: {
	payPeriodId: string;
	search?: string;
	page?: number;
	pageSize?: number;
	sortField?: string;
	sortOrder?: string;
}) => {
	return await getApi('/dashboard/employees', params);
};

export const dashboardApi = {
	getDashboardSummary,
	getDashboardEmployees,
};
